// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__XoCoM","label":"styles_label__toqap","caption":"styles_caption__jsNU2","description":"styles_description__DLhnr","content":"styles_content__oSomz"};